module.exports = __webpack_public_path__ + "static/img/ptGame4.fb9be30.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/ptGame4.webp
// module id = VFz9
// module chunks = 3